export const GET_PURCHASE_DATA = 'GET_PURCHASE_DATA';
export const GET_PURCHASE_DATA_SUCCESS = 'GET_PURCHASE_DATA_SUCCESS';
export const GET_PURCHASE_DATA_FAILED = 'GET_PURCHASE_DATA_FAILED';

export function getPurchaseHistory() {
    return {
        type: GET_PURCHASE_DATA,
    };
}
